import { render, staticRenderFns } from "./AdminActiveSharesPage.vue?vue&type=template&id=0cf2bf6b"
import script from "./AdminActiveSharesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminActiveSharesPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports